<template>
  <ConfigErrorBoundary>
    <FileCompressor
      :config="compressorConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    />
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileCompressor from './FileCompressor.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateCompressorConfig } from '../utils/ConfigValidator';

// Parse and validate configuration using fail-fast Zod validation
const compressorConfig = parseAndValidateCompressorConfig('image-compressor', 'Image Compressor');

// Event handlers
function handleBatchCreated(batchId: string) {
  console.log('[Image Compressor] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[Image Compressor] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[Image Compressor] Batch cleared');
}

function handleError(error: Error) {
  console.error('[Image Compressor] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[Image Compressor] Credits updated:', credits);
}
</script>
